import { render, staticRenderFns } from "./build-num-stat.vue?vue&type=template&id=8a447ee6&scoped=true&"
import script from "./build-num-stat.vue?vue&type=script&lang=js&"
export * from "./build-num-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a447ee6",
  null
  
)

export default component.exports